<template>
  <div>
    <label>
      <p>画像</p>
    </label>
    <div>
      <div class="preview" v-if="url && url.length">
        <img :src="url" class="img-responsive" />
      </div>
      <p v-if="!url" class="description">
        いずれかの方法で画像を利用して下さい。
      </p>
      <div v-if="!url" class="form">
        <div class="form-upload">
          <h3>ファイルアップロード</h3>
          <img
            v-if="isUploading"
            src="@images/loading.gif"
            class="loading-gif"
          />
          <input type="file" @change="fileSelected($event)" />
        </div>
        <div v-if="!url" class="form-quote-image">
          <h3>引用画像</h3>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder="画像のURLを入力してください。"
              v-model="quoteUrl"
            />
            <button @click="check($event)" class="btn-normal">チェック</button>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-6">
        <label for="">alt</label>
        <input type="text" v-model="alt" class="form-control" />
      </div>
    </div>
    <div>
      <button @click="emit()">追加</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageUploader',
  data() {
    return {
      isUploading: false,
      alt: '',
      url: '',
      quoteUrl: '',
      width: '',
      height: '',
    };
  },
  methods: {
    emit() {
      if (!this.alt) {
        alert('altを入力してください');
        return;
      }
      if (!this.url) {
        alert('画像を指定してください');
        return;
      }
      const image = {
        alt: this.alt,
        url: this.url,
        width: this.width,
        height: this.height,
      };
      if (!this.url) {
        delete image.url;
      }
      this.$emit('add', image);
      this.alt = '';
      this.url = '';
      this.quoteUrl = '';
      this.width = '';
      this.height = '';
    },
    check(e) {
      e.preventDefault();
      this.isUploading = true;

      $.post({
        url: '/api/image/quote',
        type: 'POST',
        data: {
          url: this.quoteUrl,
        },
        success: (data) => {
          console.log(data);
          this.isUploading = false;
          this.url = data.url;
          this.width = data.width;
          this.height = data.height;
        },
        error: () => {
          this.isUploading = false;
          alert(
            '無効なURLです。og:image(シェア用の画像リンクの指定)が設定されているURLか、画像URLのみ入力できます'
          );
        },
      });
    },
    fileSelected(e) {
      const files = e.target.files;
      if (!files.length) return;
      const fd = new FormData();

      fd.append('image', files[0]);

      this.isUploading = true;

      $.post({
        url: '/api/image/upload',
        type: 'POST',
        data: fd,
        processData: false,
        contentType: false,
      })
        .then((response) => {
          this.isUploading = false;
          this.url = response.url;
          this.width = response.width;
          this.height = response.height;
        })
        .catch((err) => {
          console.error(err);
          this.isUploading = false;
          alert('アップロードに失敗しました。');
          return false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.store-input-form {
  background-color: #eee;
  position: relative;
  padding: 15px 15px 1px;
  margin: 0 0 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}

.container {
  display: flex;
  flex-direction: row;
  gap: 12px;

  &__item {
    flex-basis: 50%;
  }
}

.form-group {
  &__item {
    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }

  &__footer {
    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }
}

.ql-editor {
  font-size: 15px;
}

.store {
  border: 1px solid lightgrey;
  border-radius: 4px;
  padding: 12px;
  font-size: 14px;

  &__head {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__score {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__score-star {
    color: #fab704;
  }

  &__text {
    margin-top: 12px;
  }

  &__links {
    margin-top: 12px;
  }

  &__link-item {
    margin-top: 8px;
    margin-left: 12px;

    &:nth-child(n + 2) {
      border-top: 1px dotted gray;
      padding-top: 8px;
    }
  }

  &__link-empty {
    margin-top: 8px;
    margin-left: 12px;
  }
  &__images {
    display: flex;
    gap: 2px;
  }
  &__image {
    margin-top: 2px;
    > img {
      width: 100%;
      object-fit: contain;
    }
  }
}
</style>
